import * as CortexDecoder from '@/assets/js/CortexDecoderWeb';
import ToastService from '@/modules/toasts/services/ToastService';
import WCSimpleToast from '@/modules/toasts/components/WCSimpleToast/WCSimpleToast.vue';

export default {
  async initialize(cortexKey) {
    if (!cortexKey) {
      console.error('No license key for Cortex is configured');
      ToastService.open(WCSimpleToast, {
        props: {
          variant: 'danger',
          title: 'Accelerated Checkout',
          message: 'The scanner for Accelerated Checkout is not configured correctly.',
        },
        timeout: 7000,
      });
      return;
    }

    await CortexDecoder.CDDecoder.init('/wasm');
    await CortexDecoder.CDLicense.activateLicense(cortexKey).catch(e => console.log(e));

    await CortexDecoder.CDCamera.init();

    this.setCameraDevice(CortexDecoder.CDCamera.getConnectedCameras());
    this.setDuplicateFilterDuration(3000); // 3 sec delay
    this.setCharacterSetEncoding('UTF8');
    this.enableScanSoundAndVibrate();
  },
  startScanning(scanHandler) {
    // start video capture
    CortexDecoder.CDCamera.videoCapturing = true;

    // start video preview
    CortexDecoder.CDCamera.getPreview(result => this.handleResult(result, scanHandler));
  },
  stopScanning() {
    /* Destroy the barcode reader stream */
    CortexDecoder.CDCamera.videoCapturing = false;
    CortexDecoder.CDCamera.stopPreview();
  },
  handleResult(result, scanHandler) {
    const results = result?.results;
    if (!results || !Object.keys(results).length) return;

    if (results.length) {
      const scanData = results[0];
      scanHandler(scanData);
    }
  },
  setCameraDevice(cameraDevices) {
    try {
      const cameras = [];
      const backCameras = [];

      cameraDevices.forEach(device => {
        if (device.label?.toUpperCase()?.includes('BACK')) {
          backCameras.push(device);
        } else {
          cameras.push(device);
        }
      });

      if (backCameras[0]) {
        CortexDecoder.CDCamera.setCameraPosition('BACK');
        CortexDecoder.CDCamera.setCamera(backCameras[0].label);
      } else {
        CortexDecoder.CDCamera.setCamera(cameras[0]?.label);
      }
    } catch (err) {
      console.log(err);
    }
  },
  setDuplicateFilterDuration(duration) {
    try {
      CortexDecoder.CDDecoder.setDuplicateDelay(duration);
    } catch (err) {
      console.log(err);
    }
  },
  setCharacterSetEncoding(type) {
    try {
      CortexDecoder.CDDecoder.characterSetEncoding = type;
    } catch (err) {
      console.log(err);
    }
  },
  enableScanSoundAndVibrate() {
    try {
      CortexDecoder.CDDevice.audio = true;
      CortexDecoder.CDDevice.vibration = true;
    } catch (err) {
      console.log(err);
    }
  },
};
